import { Route } from 'react-router-dom';
import Settings from '../../components/pageComponents/Settings';
import OfficePracticumSettings from '../../components/pageComponents/OfficePracticumSettings';

export const getSettingsRoutes = ({ isMinimized }) => {
  const pages = [
    {
      path: '/settings',
      Component: Settings,
    },
    {
      path: '/op-settings',
      Component: OfficePracticumSettings,
    },
  ];

  return pages.map((route) => {
    const { path, Component } = route;
    return (
      <Route
        key={path}
        path={path}
        element={<Component isMinimized={isMinimized} />}
      />
    );
  });
};
